import { createSelector } from 'reselect'
import { EmptyArray } from 'lib/array/arrayUtils'
import { getFlightItemsView } from 'checkout/selectors/view/flights'
import { FlightLoyaltyProductType } from 'lib/flights/flightUtils'
import { getPromoKeyForLoyaltyItem } from 'lib/promo/promoMappers'

const getCheckoutFlightsPointsCalculationRequests = createSelector(
  (state: App.State) => getFlightItemsView(state),
  (state: App.State) => state.checkout.promo?.loyaltyPointsBonusResultV1,
  (flightsViews, loyaltyPointsBonusResultV1): Array<App.LoyaltyDefaultPointsEarnCalculationRequest> => {
    if (!flightsViews.hasRequiredData) return EmptyArray

    return flightsViews.data.map((itemView: App.Checkout.FlightItemView): App.LoyaltyDefaultPointsEarnCalculationRequest => ({
      price: itemView.totals.price,
      loyaltyProductType: itemView.loyalty.productType as FlightLoyaltyProductType,
      itemId: itemView.item.itemId,
      promoKey: getPromoKeyForLoyaltyItem(loyaltyPointsBonusResultV1, { filter: { itemId: itemView.item.itemId } }),
    }))
  },
)

export default getCheckoutFlightsPointsCalculationRequests
